import script from "./AdminAffiliatePayouts.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAffiliatePayouts.vue?vue&type=script&setup=true&lang=js"

import "./AdminAffiliatePayouts.vue?vue&type=style&index=0&id=bbc0ef28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbc0ef28"]])

export default __exports__